import { ModelBase } from '../../core/model/model-base';

export class InvoiceAccounting extends ModelBase {
  constructor() {
    super();
  }

  accountName: string;
  accountNumber: string;
  businessTransactionDate: string;
  costPlace: string;
  costBearer: string;
  counterpart: string;
  creationDate: string;
  credit: string;
  debit: string;
  function: string;
  project: string;
  verificationDescription: string;
  verificationNumber: string;
}

export class InvoiceAccountingBalance extends ModelBase {
  constructor() {
    super();
  }

  accountName: string;
  accountNumber: string;
  costPlace: string;
  costBearer: string;
  counterpart: string;
  creationDate: string;
  credit: string;
  debit: string;
  function: string;
  project: string;
}
